<template>
<div>
	<Row style="padding:10px 10px;" class="model-table">
		<Col :span="dialog.leftTree?5:0" v-if="display">
			<Tree ref="leftTree" :data="leftTreeData" v-if="!isLeftTreeConfigType('formCustDialog')" @on-select-change="leftTreeChange"></Tree>
			
			<ab-cust-dialog-tree ref="leftTreeDialog" v-if="isLeftTreeConfigType('formCustDialog')&&leftTreeDialog" :dialog="leftTreeDialog" :initData="[]" :param="leftTreeDialogParam" :expand="expand" :selectChange="leftTreeChange"></ab-cust-dialog-tree>
		</Col>
		
		<Col :span="dialog.leftTree?19:24">
			<Row>
				<Form ref="searchForm" :model="searchParam" class="searchForm">
					<Row type="flex" justify="start">
						<Col span="6" v-for="field in dialog.conditionFields" v-show="field.valueSource=='param'&&field.value.ctrlType" style="margin-bottom:15px;">
				        	<FormItem :label="field.showName + ':'" :prop="field.searchName">
				        		<Input type="text" v-model="searchParam[field.searchName]" @on-enter="postPageData" :placeholder="'请输入'+field.showName"  clearable></Input>
				        	</FormItem>
			        	</Col>
			        	<Col style="float: right;" span="6" v-if="showSearchBtn">
		            		<Button icon="ios-search" style="margin-left: 10px" type="primary" @click="postPageData">{{$t('page.common.search')}}</Button>
		            		<Button icon="md-refresh"  style="margin-left: 10px" @click="reset">{{$t('page.common.reset')}}</Button>
			        	</Col>
		        	</Row>
		       	</Form>
			</Row>
		
			<Row style="margin-top:20px;">
				<Col :span="listLeftSpan">
					<Table border class="table_list_modal" :height="height" ref="selection" :loading="loading" :columns="columns" :data="pageData.rows"
						@on-row-click="rowClick" @on-sort-change="sortChange" @on-select="select" @on-select-cancel="selectCancel"
						@on-select-all="selectAll" @on-select-all-cancel="selectAllCancel">
					</Table>
				</Col>
				<Col :span="listRightSpan" v-if="dialog.multiple">
					<!-- 已选列表 -->
					<Table border :height="height" style="margin-left:5px;" :columns="scolumns" :data="sdata">
						<template slot-scope="{row,index}" slot="action">
			            	<Button shape="circle" icon="ios-trash" @click="removeSelect(row,index)"></Button>
				        </template>
					</Table>
				</Col>
			</Row>
			<Row>
				<Col span="24">
					<div style="margin-left: 1%; margin-top: 10px;">
						<Page :total="pageData.total" :current="page" :page-size="pageSize" show-sizer show-elevator show-total @on-change="pageChange" @on-page-size-change="pageSizeChange" />
					</div>
				</Col>
			</Row>
		</Col>
	</Row>
</div>
</template>

<script>
import Vue from 'vue';
import abCustDialogTree from './ab-cust-dialog-tree.vue';
export default {
	components:{
		abCustDialogTree
	},
	props: ["dialog","initData","param",'display','noneSelect',"expand","defaultData"],
  	data :function () {
	    return {
	    	loading : true,
	    	isFirstLoading : true,
	    	page : 1,
	    	pageSize : 10,
	    	sort : "",
	    	order : "",
	    	columns : [{
    		 	type: 'selection',
    		 	width: 60,
    		 	align: 'center'
	    	}],
	    	pageData : {
	    		rows : [],
	    		total : 10
			},
	    	height : "",
	    	scolumns : [],
	    	sdata : [],
	    	searchParam : {},
			showSearchBtn : false,
			listLeftSpan : 24,
			listRightSpan : 0,
			leftTreeData : [],
			conditionFieldsMap : {},
			leftTreeDialog : null,
			leftTreeDialogParam : {},
	    }
	},
 	mounted : function(){
 		this.sdata = this.abTools.CloneUtil.list(this.initData);
 		
 		let h = this.dialog.height;
 		if(this.dialog.height <= 100){
 			h =  window.innerHeight * ("0." + this.dialog.height);
 		}
 		this.height = h - (this.dialog.conditionFields.length/3 + 2) * 55 - 95;
 		

 		this.dialog.displayFields.forEach(field => {
 			let column = {
 				title : field.showName,
 				key : field.columnName,
 				sortable : "custom"
 			};
 			if(field.formatter){
 				column.render = function(h, params){
 					let row = params.row;
 					let value = row[field.columnName];
 					let index = params.index;
 					eval("field.func = function(value, row, index){"+ field.formatter +"}");
 					let html = field.func(value, row, index);
 					let rlt = h("div", {
 						domProps : {
 							innerHTML : html
 						}
 					});
				  	return rlt;
 				}
 			}
			 this.columns.push(column);
 		});

 		this.dialog.conditionFields.forEach(field => {
 			var searchName = field.columnName + "$";
 			if (field.dbType === "varchar") {
 				searchName += "V";
 			}
 			if (field.dbType === "number") {
 				searchName += "N";
 			}
 			if (field.dbType === "date") {
 				searchName += "D";
 			}
 			searchName += field.condition;
 			field.searchName = searchName;
 			if(this.param&&this.param[field.columnName]){
 				this.param[searchName] = this.param[field.columnName];
 			}
 			if(field.valueSource=='param'&&field.value.ctrlType){
 				this.showSearchBtn = true;
 			}
 			this.conditionFieldsMap[field.columnName] = field;
 		});

 		this.scolumns.push({
 			title:this.dialog.displayFields[0].showName,
 			key : this.dialog.displayFields[0].columnName
 		});

 		this.scolumns.push({
 			title:"操作",
 			slot: 'action',
 			width: '70',
		 });
		 
		 // 判断操作栏的占比
		 if(this.dialog.multiple){
			this.listLeftSpan = 18;
			this.listRightSpan = 6;
			 // 判断列的宽度
			 if(this.columns.length ==3){
			 	this.listLeftSpan = 16;
			 	this.listRightSpan = 8;
			 }
			 if(this.columns.length ==2){
			 	this.listLeftSpan = 14;
			 	this.listRightSpan = 10;
			 }
		 }
		 console.log(this.noneSelect)
		 console.log(this.columns,'当前列')
		 if(this.noneSelect){
		 	this.columns.splice(0,1)
		 }
		this.columns.forEach(val=>{
			if(val.title){
				var length = val.title.length
				val.width = length > 7 ? 200 : 150
			}
		})
 		this.postPageData();
 		this.handleLeftTree();
 	},
	methods: {
		rowClick : function(item,index){
			if(!this.dialog.multiple){//单选
				for(let i in this.$refs.selection.objData){
					this.$refs.selection.objData[i]._isChecked = false;
				}
				this.$refs.selection.objData[index]._isChecked = true;
				this.sdata = [item];
				return;
			}

			//多选
			this.$refs.selection.objData[index]._isChecked = !this.$refs.selection.objData[index]._isChecked;
			this.handleSdata(item,this.$refs.selection.objData[index]._isChecked);
		},
		sortChange : function(data){
			this.order = data.order;
		  	this.sort = data.column.key;
		  	this.postPageData();
		},
		// 选择分页
		pageChange : function(page) {
			this.page = page;
			this.postPageData();
		},
		// 选择页面大小
		pageSizeChange : function(pageSize) {
			this.page = 1;
			this.pageSize = pageSize;
			this.postPageData();
		},
		//获取页面数据
	  	postPageData : function(){

			//liuhaijiang 
			if(this.defaultData && this.defaultData.length>0 && this.isFirstLoading){
				this.pageData.total = this.defaultData.length;
				this.pageData.rows = this.defaultData;
				this.loading = false;
				this.isFirstLoading = false;
				return;
			}

	  		let param = {
  				"offset" : (this.page - 1) * this.pageSize,
  				"limit" : this.pageSize,
  				"sort" : this.sort,
  				"order" : this.order
  			};
	  		if(this.searchParam){
	  			this.abTools.extend(this.param||{},param);//赋值页面来的参数
		  		this.abTools.extend(this.searchParam,param);
		  	}
  			let url = "/form/formCustDialog/listData_" + this.dialog.key;
  			this.loading = true;
  			let post = Vue.abHttpUtil.postForm(url, param);
	  		post.then(result => {
	  			this.loading = false;
				this.pageData = result;

				this.checkInitSelected();

	  			//用笨的方法修改i-table组件中的全选按钮失效（必须要延迟执行才会生效）
	  			if(!this.dialog.multiple){
	  				setTimeout(()=>{
	  					this.$refs.selection.$el.children[0].children[0].children[0].children[1].children[0].children[0].children[0].children[0].children[0].style.display = "none";
	  				},100)
	  	 		}
	  		}, function (status) {
		  		if (status == !0) {
			  		Vue.prototype.$Message.error('加载失败！' + status);
  			  	}
  			});
	  	},
	  	select : function(list,row){
	  		if(!this.dialog.multiple){//单选
				for(let i in this.$refs.selection.objData){
					if(!this.dialogEqual(row,this.$refs.selection.objData[i])){
						this.$refs.selection.objData[i]._isChecked = false;
					}
				}
				this.sdata = [row];
				return;
			}
	  		//多选
	  		this.handleSdata(row,true);
	  	},
	  	selectCancel : function(list,row){
			if(!this.dialog.multiple){//单选
				this.sdata = [];
				return;
			}
			//多选
			this.handleSdata(row,false);
		},
		removeSelect:function(row,index){
			this.sdata.splice(index,1);
			for(let i in this.$refs.selection.objData){
				if(this.dialogEqual(row,this.$refs.selection.objData[i])){
					this.$refs.selection.objData[i]._isChecked = false;
				}
			}
		},
		// 默认选中回显的数据
		checkInitSelected:function(){
			if(this.pageData.rows && this.pageData.rows.length>0){
				for(var j =0 ; j < this.pageData.rows.length ; j++){
					var pd = this.pageData.rows[j];
					pd._checked = false;
				}
			}
			
			if(this.sdata && this.sdata.length>0 && this.pageData.rows && this.pageData.rows.length>0){
				for(var i =0 ; i < this.sdata.length ; i++){
					var sd = this.sdata[i];
					for(var j =0 ; j < this.pageData.rows.length ; j++){
						var pd = this.pageData.rows[j];
						if(this.dialogEqual(sd,pd)){
							pd._checked = true;
							break;
						}
					}
				}
			}
		},
	  	handleSdata : function(item,add){
	  		let sindex = -1;
			this.sdata.forEach((ite,idx) => {
				if(this.dialogEqual(ite,item)){
					sindex = idx;
				}
			});

			if(add && sindex == -1){//新增
				this.sdata.push(item);
			}
			if (!add && sindex != -1){//删除
				this.sdata.splice(sindex,1);
			}
	  	},
	  	selectAll : function(list){
	  		this.pageData.rows.forEach(item =>{
	  			this.handleSdata(item,true);
	  		});
	  	},
	  	selectAllCancel : function(list){
	  		this.pageData.rows.forEach(item =>{
	  			this.handleSdata(item,false);
	  		});
	  	},
	  	reset : function(){
	  		this.searchParam = {};
	  		this.postPageData();
	  	},
	  	getData : function(){
  			return this.sdata;
	  	},
	  	// 仅以a中存在的字段跟b作相等比较（可以理解为a字段少，b字段多）
	  	dialogEqual : function(a,b){
			for(let key in a){
				if(a[key] != b[key] && !key.startsWith('_')){
					return false;
				}
			}
			return true;
	  	},
	  	handleLeftTree(){
	  		if(!this.dialog.leftTree){
	  			return;
	  		}
	  		
	  		if(this.isLeftTreeConfigType("sysTree")){
	  			let url = "/sys/sysTreeNode/getNodes";
		    	let post = Vue.abHttpUtil.postForm(url, {
		    		treeKey : this.dialog.leftTreeConfig.key,
					rootName : this.dialog.leftTreeConfig.rootName
		   	  	});
		   	 	post.then(data => {
		   		  	this.leftTreeData = this.buildTree(data);
		       	});
	  		}
	  		
	  		if(this.isLeftTreeConfigType("dataDict")){
	  			let url = "/sys/dataDict/getDictData";
		    	let post = Vue.abHttpUtil.postForm(url, {
		    		dictKey : this.dialog.leftTreeConfig.key,
		    		hasRoot : this.dialog.leftTreeConfig.rootName ? true : false
		   	  	});
		    	Vue.abTools.getResultData(post, data => {
		    		this.leftTreeData = this.buildTree(data);
		    	});
	  		}
	  		
	  		if(this.isLeftTreeConfigType("formCustDialog")){
				
				if(this.param){
					this.leftTreeDialogParam = {...this.param.leftTreeDialogParam}
				}

	  			let url = "/form/formCustDialog/getObject";
	  	  		let post = Vue.abHttpUtil.postForm(url, {
	  	  			key : this.dialog.leftTreeConfig.key
	  		  	});
	  		  	Vue.abTools.getResultData(post, data => {
	  		  		if(this.isRootName()){//增加根节点
	  		  			this.leftTreeDialogParam["rootName"] = this.dialog.leftTreeConfig.rootName;
	  		  		}
	  		  		this.leftTreeDialog = this.abTools.extend({
	  		  			multiple : false
	  		  		},data);
	  	      	});
	  		}
	  	},
 		buildTree : function(data, parentId){
  	  		if(!parentId){//找到根节点
		  		data.forEach(item => {
		  			var root = true;
		  			data.forEach(ite => {
					  	if(item.parentId == ite.id){
					  		root = false;
					  	}
	  				});
	  				if(root){
	  					parentId = item.parentId;
	  				}
	  			});
  	  		}
    		  
          	let tree = [];
          	let temp;
          	for (let i = 0; i < data.length; i++) {
              	if (data[i].parentId == parentId) {
            	  	let obj = data[i];
                  	temp = this.buildTree(data, data[i].id);
                  	if (temp.length > 0) {
                      	obj.children = temp;
                  	}
               	  	obj.title = obj.name;
               	  	if(this.isLeftTreeConfigType("dataDict")&&this.isRootName()&&obj.dictType=="dict"){
               	  		obj.title = this.dialog.leftTreeConfig.rootName;
               	  	}
                  	obj.expand = true;
                  	tree.push(obj);
              	}
          	}
          	return tree;
   	  	},
   	 	leftTreeChange(nodes,node){
   	  		let field = this.conditionFieldsMap[this.dialog.leftTreeConfig.condField];
   	  		let value = "";
   	  		if(this.isLeftTreeConfigType("sysTree")){
   	  			if(!this.isRootName()||node.id!="-1"){
   	  				value = node.id;
   	  			}
   	  		}
	   	  	if(this.isLeftTreeConfigType("dataDict")){
	   	  		if(!this.isRootName()||node.dictType!="dict"){
	  				value = node.key;
	  			}
	   	  	}
	   	 	if(this.isLeftTreeConfigType("formCustDialog")){
	   	  		if(!this.isRootName()||node[this.leftTreeDialog.treeConfig.showColumn]!=this.dialog.leftTreeConfig.rootName){
	  				value = node[this.leftTreeDialog.treeConfig.id];
	  			}
	   	  	}
   	  		this.$set(this.searchParam,field.searchName,value);
   	  		this.postPageData();
   	  	},
   	  	isLeftTreeConfigType(type){
	   	  	if(!this.dialog.leftTree){
	  			return false;
	  		}
   	  		return this.dialog.leftTreeConfig.type==type;
   	  	},
   	 	isRootName(){
   	  		return !!this.dialog.leftTreeConfig.rootName;
   	  	},
  	},
 	watch : {
 	}
}
</script>
